<div class="container-fluid sticky-toolbar">
  <div class="sticky-toolbar-content">
    <!-- Calendar -->
    <ng-container *ngIf="showCalendar">
      <div class="sticky-toolbar__label">{{ labelText }}</div>
      <div class="calendar-container">
        <div class="input-group-container">
          <i class="fa fa-calendar calendar-addon input-group-container-addon"></i>
          <invd-fm-date-picker
            class="calculate-fee__date-picker sticky-input"
            datePickerId="asOfDateCalendarId"
            placeholderText="mm/dd/yyyy"
            (dateValueChange)="setAsOfDate($event)"
            [dateValue]="mDateValue"
          >
          </invd-fm-date-picker>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="showClearAllButton">
      <div class="button-1-container-clear">
        <button type="button" class="button-1-clear" (click)="onClearButtonClicked(true)">
          {{ clearAllButtonText }}
        </button>
      </div>
    </ng-container>
    <!-- End Calendar -->

    <ng-container *ngIf="showCancelButton">
      <div class="button-1-container-clear">
        <button type="button" class="button-1-clear" (click)="cancelButtonClicked()">
          {{ cancelText }}
        </button>
      </div>
    </ng-container>

    <!-- Call To Action -->
    <div class="button-2-container">
      <button type="button" class="button-2" (click)="onButtonClicked(true)">
        {{ buttonText }}
      </button>
    </div>
    <!-- End Call To Action -->
  </div>
</div>
